import { Cache } from '@stt-componentes/cache';
import axios from 'axios';
import { emitirAlertaErro } from '../signals/alerta';

export const getHeaders = () => {
    const token = Cache.getAccessToken();
    return { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' };
};

export const http = axios.create();

// injeta baseURL + headers de auth em toda requisição
// options => config
http.interceptors.request.use((config) => {
    config.baseURL = config.baseURL || global.gConfig.url_base_console;
    config.headers = { ...getHeaders(), ...config.headers };
    return config;
});

// emite alerta automaticamente, exceto em cancelamentos ou opt-out via config.silenciarErro
http.interceptors.response.use(
    (response) => response,
    (error) => {
        // options => config
        if (!axios.isCancel(error) && error.config?.silenciarErro !== true) {
            emitirAlertaErro(error, { mensagemPadrao: error.config?.mensagemErroPadrao });
        }
        return Promise.reject(error);
    },
);
